import script from "./BaseTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTitle.vue?vue&type=script&setup=true&lang=js"

import "./BaseTitle.vue?vue&type=style&index=0&id=b1af1a80&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1af1a80"]])

export default __exports__